


















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CustomerImportEmailSent extends Vue {
  @Prop({ default: '246' }) readonly width?: string;
  @Prop({ default: '233' }) readonly height?: string;
}
